import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Portfolio } from '../components/Portfolio';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-gray-900" data-id="element-210">
      <Navigation data-id="element-211" />
      <main data-id="element-212">
        <Hero data-id="element-213" />
        <Services data-id="element-214" />
        <Portfolio data-id="element-215" />
        <Process data-id="element-216" />
        <Testimonials data-id="element-217" />
        <CTASection data-id="element-218" />
      </main>
      <Footer data-id="element-219" />
    </div>;
}